export const nullableMetricNumber = value => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const metricPercentage = value => {
  const number = nullableMetricNumber(value);
  return number === null ? null : number * 100;
};

export const averageSaleValue = (total, count) => {
  const amount = nullableMetricNumber(total);
  const sales = nullableMetricNumber(count);
  return amount === null || sales === null || sales <= 0 ? null : amount / sales;
};

export const formatMetricValue = (value, type, formatTime) => {
  const number = nullableMetricNumber(value);
  if (number === null) return '—';
  if (type === 'currency') return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);
  if (type === 'percent') return `${number.toFixed(1)}%`;
  if (type === 'time') return formatTime(number);
  return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(number);
};
